<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/common/SideTree.vue